import React from 'react';
import Grid from '@material-ui/core/Grid'

import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Lock from '../../img/brow/add lock.svg'
import { ProgressBar, Button } from 'react-bootstrap';
import Clander from '../Clander/index'


import './Tabs.css'

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));

export default function SimpleTabs() {
  const percentage = 0;
  const percentage1 = 0;
  const percentage2 = 0;
  const percentage3 = 0;

  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <AppBar position="static" >
        <Tabs value={value} onChange={handleChange} aria-label="simple tabs example">
          <Tab className="Tabs1"  label="New locks" {...a11yProps(0)} />
          <Tab className="Tabs1" label="View locks" {...a11yProps(1)} />
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0} className="px-sm-5" style={{color:'black'}}>
       
        <div className="Locks--section1 py-3 px-5 ">
            <h3>Locks (0)</h3>
        </div>
        <div className="Locks--section2 py-3 px-5 text-center ">
            <button className="py-2 px-4"><img src={Lock} alt="Lock Logo" className="mr-2" />Add a lock</button>
        </div>
        <div className="Locks--section3 py-3 px-5 text-center ">
            <p>0 /0.010458778290865132 pCATv3 total locked</p>
        </div>
           
       
      </TabPanel>
      <TabPanel value={value} index={1} style={{color:'black'}}>
      <div className="Locks--section1 py-3 px-5 ">
            <h3>Locks (0)</h3>
        </div>
        <div className="view--Locks--section2 py-4 px-md-5">
            <div className="lock--token-1section py-4 px-4">
            <p className="mb-3"><strong>Lock how many tokens?</strong></p> 
             <div className="lock--token py-4 px-4">
                 <p className="word text-right">Balance: 0.010458778</p>
                 <h4 style={{float:'left'}}> 
                  <input className="input" type="text" placeholder="0.0" />
                </h4>
                <h4 className="text-right decimal">pCATv3 <button className="lcock--button">Max</button></h4>
              </div>
              <div className="px-3" style={{backgroundColor: '#efefef'}} >
                <div class=" row text-center pt-3 pb-5" >
                  <div  class="col-3 px-0 pl-2">
                  <button className="buttonper pt-2">25%</button>
                  </div>
                  <div  class="col-3 px-0">
                  <button className="buttonper pt-2">50%</button>
                  </div>
                  <div  class="col-3 px-0">
                  <button className="buttonper pt-2">75%</button>
                  </div>
                  <div  class="col-3 px-0 pr-2">
                  <button className="buttonper pt-2">100%</button>
                  </div>
                 
                </div>
              </div>
             <div>
               <p className="mt-3"><strong >Unlock on date</strong></p>
               <div className="lock--token py-4 px-4">
               <Clander/>
               </div>
             </div>

            </div>
           
        </div>
       
      </TabPanel>
     
    </div>
  );
}
